module.exports = __webpack_public_path__ + "~@/assets/img/mac.13437c85.jpg";